import React, { useEffect, useState } from "react";
import { Button, Typography } from "@material-ui/core";
import Modal from "@/components/Modal";
import { useTranslation } from "@/langs/useTranslation";
import MemoedHOC from "@/hoc/MemoedHOC";
import ManagerList from ".";
import styles from "./index.module.less";

function Index({ open, defaultList, list, onConfirm, onChange, onClose }) {
  const { t } = useTranslation();
  // const defaultList = useRef(list);
  const [innerList, setInnerList] = useState([]);

  const handleConfirm = () => {
    return onConfirm?.(innerList);
  };

  const handleChange = list => {
    setInnerList(list);
    onChange?.(list);
  };

  const handleRestore = () => {
    handleChange(defaultList);
  };

  useEffect(() => {
    setInnerList(list);
  }, [list]);

  // useEffect(() => {
  //   if (open) {
  //     defaultList.current = list;
  //   }
  // }, [open, list]);

  return (
    <Modal
      title={t({ defaultMessage: "自定义显示" })}
      width={500}
      open={open}
      onClose={onClose}
      onConfirm={handleConfirm}
      confirmText={t({ defaultMessage: "保存" })}
    >
      <Typography variant="body2" color="textSecondary" className={styles.desc}>
        {t({ defaultMessage: "勾选需要显示的栏位" })}
      </Typography>
      <ManagerList value={innerList} onChange={handleChange} />
      <Button
        color="primary"
        style={{ position: "relative", top: 62 }}
        onClick={handleRestore}
      >
        {t({ defaultMessage: "恢复默认" })}
      </Button>
    </Modal>
  );
}

export default MemoedHOC(Index);
